import React, { useState, useEffect, useRef } from 'react';

const images = [
  { src: '/valdelsa_fuochi.png', alt: 'Fuochi d\'artificio sulla Fortezza', caption: 'La Fortezza si accende' },
  { src: '/borgo_sangimignano.png', alt: 'San Gimignano al tramonto', caption: 'San Gimignano — Le torri medievali' },
  { src: '/valdelsa_sbandieratori.png', alt: 'Sbandieratori nella piazza', caption: 'Sbandieratori — La tradizione viva' },
  { src: '/borgo_monteriggioni.png', alt: 'Monteriggioni — La corona di torri', caption: 'Monteriggioni — Corona di torri' },
  { src: '/valdelsa_torri_colori.png', alt: 'Le torri illuminate di colori', caption: 'Le Torri illuminano la notte' },
  { src: '/borgo_casole.png', alt: 'Casole d\'Elsa tra gli ulivi', caption: 'Casole d\'Elsa — Tra ulivi e grano' },
  { src: '/valdelsa_castello.png', alt: 'Castello dall\'alto', caption: 'Il Castello — Guardiano della Valdelsa' },
  { src: '/borgo_poggibonsi.png', alt: 'Poggibonsi — Fortezza Medicea', caption: 'Poggibonsi — Fortezza Medicea' },
  { src: '/valdelsa_fonti.png', alt: 'Le Fonti medievali illuminate', caption: 'Le Fonti — Dove il tempo si ferma' },
  { src: '/borgo_collevaldelsa.png', alt: 'Colle Val d\'Elsa — Colle Alta', caption: 'Colle Val d\'Elsa — La citta del cristallo' },
  { src: '/bottega_hero.png', alt: 'La Bottega delle Arti Perdute', caption: 'La Bottega — Senatori e Gen Alpha insieme' },
  { src: '/bottega_pasta.png', alt: 'La cucina della nonna', caption: 'La Cucina della Nonna — Arti che non muoiono' },
];

const ValdelsaGallery = () => {
  const [active, setActive] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setActive(prev => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const goTo = (i) => {
    clearInterval(intervalRef.current);
    setActive(i);
    intervalRef.current = setInterval(() => {
      setActive(prev => (prev + 1) % images.length);
    }, 5000);
  };

  return (
    <section data-testid="valdelsa-gallery" className="relative overflow-hidden" style={{ height: '70vh', minHeight: '400px' }}>
      {/* Images */}
      {images.map((img, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{ opacity: i === active ? 1 : 0, zIndex: i === active ? 1 : 0 }}
        >
          <img src={img.src} alt={img.alt} className="w-full h-full object-cover" />
        </div>
      ))}

      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]/40 z-10" />

      {/* Caption */}
      <div className="absolute bottom-0 left-0 right-0 z-20 p-8">
        <div className="max-w-5xl mx-auto flex items-end justify-between">
          <div>
            <p className="text-[#00FF41] font-mono font-black text-xs uppercase tracking-[0.3em] mb-2">
              Valdelsa — Il nostro territorio
            </p>
            <p className="text-white font-black text-2xl md:text-3xl font-mono transition-all duration-500">
              {images[active].caption}
            </p>
          </div>

          {/* Dots */}
          <div className="flex gap-2">
            {images.map((_, i) => (
              <button
                key={i}
                data-testid={`gallery-dot-${i}`}
                onClick={() => goTo(i)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === active ? 'bg-[#00FF41] scale-125' : 'bg-white/30 hover:bg-white/60'}`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Side nav arrows */}
      <button
        onClick={() => goTo((active - 1 + images.length) % images.length)}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 flex items-center justify-center bg-black/40 hover:bg-black/70 text-white/80 hover:text-[#00FF41] rounded-full transition-all"
        data-testid="gallery-prev"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
      </button>
      <button
        onClick={() => goTo((active + 1) % images.length)}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 flex items-center justify-center bg-black/40 hover:bg-black/70 text-white/80 hover:text-[#00FF41] rounded-full transition-all"
        data-testid="gallery-next"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
      </button>
    </section>
  );
};

export default ValdelsaGallery;
